import DndKitGroup from './Group.mjs';
import { DndKitItem as forwardedRefDndKitItem } from './Item.mjs';

const DndKit = {
  Item: forwardedRefDndKitItem,
  Group: DndKitGroup
};

export { DndKit as default };
//# sourceMappingURL=index.mjs.map
